import React, { useEffect, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { unstake } from '../../httpcalls/contractThunk';
import { Center } from '@mantine/core';
import Tilt from 'react-parallax-tilt';


const B_Resources = (props) => {
    const dispatch = useDispatch();


    return (
        <>

        </>
    );
};

export default B_Resources;
